<template>
  <div class="ms-textarea ms-editor flex" :class="{disabled: disabled, 'ms-validate': isValidate}">
    <label v-if="label"  class="label">{{ label }}</label>

    <div class="flex-row border" :class="{error: errorMessage, disabled: disabled}">
      <textarea
        ref="input"
        v-model="internalText"
        class="ms-textarea-item flex"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
      <div v-if="errorMessage" class="icon24 error error-icon" />
    </div>
    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {useValidateControl} from '@/setup/validateControl.js';

export default {
  name: 'Descriptionarea',
  extends: msBaseComponent,
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      default: null,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    // class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    // ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    title: {
      default: null,
      type: String,
    },
  },
  setup(props) {
    const {errorMessage, validate, isValidate} = useValidateControl({props});
    return {
      errorMessage,
      validate,
      isValidate,
    };
  },
  data() {
    return {
      internalText: this.modelValue,
      focused: false,
    };
  },
  computed: {
    listeners() {
      return {
        blur: e => {
          this.validate();
          this.onBlur(e);
        },
        focus: e => {
          this.onFocus(e);
          this.autoExpand(e);
          this.$emit('changeRowHeight');
        },
        change: e => {
          this.cancelEvent(e);         
          this.$emit('change', this.internalText, e);
        },
        keydown: e => {
          this.keyDownInput(e);
        },
        input: e => {
          this.autoExpand(e);
        },
        wheel: e => {
          e.preventDefault();
          const delta = Math.sign(e.deltaY);
          e.target.scrollTop += delta * 52;
        }
      };
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.validate(newVal);
        me.$emit('update:modelValue', newVal);
      },
    },
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
  },
  methods: {
    // Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    // Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
    // Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    // Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
    getValue() {
      const me = this;
      return me.internalText;
    },
    keyDownInput(e) {
      const me = this;
      let check = true;

      if (check) {
        me.$emit(me.$ms.constant.CustomEvent.MsKeydown, e, me.internalText);
      } else {
        e.preventDefault();
      }
    },
    autoExpand(e) {
      e.target.style.overflowY = "hidden";
      e.target.style.height = "auto";
      e.target.style.height = e.target.scrollHeight + "px";
      if(e.target.scrollHeight >= 78) {
        e.target.style.height = 78 + "px";
        e.target.style.overflowY = "auto";
      }
    },
    /**
     * Hủy lan rộng event
     * nhhhoang1 29.05.2023
     */
    cancelEvent(e) {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/components/DescriptionArea.scss';
</style>
